/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon16Solid = forwardRef('LightbulbIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.585 9.807c-.346.303-.585.723-.585 1.183a.01.01 0 0 1-.01.01H8.75V6a.75.75 0 1 0-1.5 0v5H5.01a.01.01 0 0 1-.01-.01c0-.46-.24-.88-.585-1.183a5.447 5.447 0 1 1 7.17 0Z" }),
        React.createElement("path", { d: "M10.57 13.538H5.439a.75.75 0 0 1 0-1.5h5.131a.75.75 0 1 1 0 1.5Z" }),
        React.createElement("path", { d: "M6.698 14.493a.75.75 0 1 0 0 1.5h2.604a.75.75 0 0 0 0-1.5H6.698Z" })));
});
